class BneMenuAnimated {
  constructor() {
    this.MOBILE_BREAKPOINT = 1280;
    this.LOGO_SCALE_THRESHOLD = 100;
    this.LOGO_SCALE_DURATION = 1000;

    this.initProperties();
    this.setupEventListeners();
    this.submenuInScreen();
  }

  initProperties() {
    if (history.scrollRestoration) {
      history.scrollRestoration = 'manual';
    } else {
      window.onbeforeunload = () => window.scrollTo(0, 0);
    }

    this.$sectionParent = document.querySelector('.m-bne-sticky-menu');
    this.$sectionToFix = this.$sectionParent?.querySelector('.m-bne-sticky-menu__wrapper');
    this.$mainContainer = document.querySelector('#MainContent');
    this.$announcementBar = document.querySelector('#shopify-section-announcement-bar');
    this.$header = document.querySelector('#shopify-section-header-v2');
    this.$logo = this.$sectionToFix?.querySelector('.js-sticky-picture');

    this.headerGroupHeight = this.calculateHeaderGroupHeight();
    this.originalPosition = this.$sectionToFix?.offsetTop || 0;
    this.newOriginalPosition = this.originalPosition - this.headerGroupHeight;

    this.state = {
      previousScrollPosition: window.scrollY,
      isMenuSticky: false,
      isLogoScaled: false,
      isTransitionEnded: false,
    };

    if (this.$sectionParent && this.$header) {
      const topValue = this.headerGroupHeight;
      this.$sectionParent.dataset.topValue = topValue;
      this.$sectionParent.style.top = this.isMobileDevice() ? `${topValue}px` : '0';
    }
  }

  setupEventListeners() {
    // only for desktop
    if (!this.isMobileDevice()) {
      this.debouncedHandleScroll = this.debounce(this.handleScroll.bind(this), 10);
      this.debouncedHandleResize = this.debounce(this.handleResize.bind(this), 20);

      window.addEventListener('scroll', this.debouncedHandleScroll);
      window.addEventListener('resize', this.debouncedHandleResize);
    }
  }

  handleScroll() {
    const { scrollY } = window;
    const { top } = this.$sectionParent.getBoundingClientRect();
    const isScrollingDown = scrollY > this.state.previousScrollPosition;

    if (top <= this.headerGroupHeight) {
      if (!this.state.isMenuSticky) this.stickMenu();
      this.handleStickyBehavior(scrollY, isScrollingDown);
    } else {
      this.unstickMenu();
    }

    if (this.state.isMenuSticky && scrollY <= this.originalPosition) {
      this.unstickMenu();
    }

    if (this.state.isTransitionEnded) {
      this.adjustStickyPosition(isScrollingDown);
    }

    this.state.previousScrollPosition = scrollY;
  }

  handleStickyBehavior(currentScrollPosition, isScrollingDown) {
    const scrollDistanceAfterSticky = currentScrollPosition - this.stickyStartScrollPosition;
    if (scrollDistanceAfterSticky > this.LOGO_SCALE_THRESHOLD) {
      this.scaleLogo(() => this.adjustStickyPosition(isScrollingDown));
    }

    this.$sectionParent.classList.toggle('js-submenu-fixed--margin', scrollDistanceAfterSticky > 100);
  }

  stickMenu() {
    this.state.isMenuSticky = true;
    this.stickyStartScrollPosition = window.scrollY;

    if (this.isMobileDevice()) {
      this.$sectionParent.style.top = `${this.$sectionParent.dataset.topValue}px`;
      this.$sectionParent.classList.add('js-submenu-fixed-mobile');
    } else {
      this.$sectionParent.classList.add('js-submenu-fixed');
      this.$sectionParent.style.top = '0';
    }
  }

  unstickMenu() {
    this.state.isMenuSticky = false;
    this.state.isLogoScaled = false;
    this.$sectionParent.classList.remove('js-submenu-fixed', 'js-submenu-fixed-mobile');
    this.resetLogoSize();

    this.$sectionParent.style.top = this.isMobileDevice() ? `${this.$sectionParent.dataset.topValue}px` : '0';
    this.$sectionParent.classList.add(this.isMobileDevice() ? 'js-submenu-fixed-mobile' : 'js-submenu-fixed');
  }

  scaleLogo(callback) {
    if (!this.$logo || this.state.isLogoScaled) return;

    this.state.isLogoScaled = true;
    this.$logo.style.transition = `width ${this.LOGO_SCALE_DURATION}ms ease-in-out`;
    this.$logo.style.width = '320px';

    if (callback) {
      this.$logo.addEventListener(
        'transitionend',
        () => {
          this.state.isTransitionEnded = true;
          callback();
        },
        { once: true }
      );
    }
  }

  adjustStickyPosition(isScrollingDown) {
    if (!this.$sectionParent) return;
    this.$sectionParent.style.top = isScrollingDown ? '0' : `${this.headerGroupHeight}px`;
  }

  resetLogoSize() {
    if (!this.$logo) return;
    this.state.isLogoScaled = false;
    this.$logo.style.transition = `width ${this.LOGO_SCALE_DURATION}ms ease-in-out`;
    this.$logo.style.width = '100%';
    this.state.isTransitionEnded = false;
  }

  submenuInScreen() {
    const navScroller = this.$sectionParent.querySelector('.nav-scroller');

    if (navScroller) {
      navScroller.scrollLeft = 0;

      const activeMenu = navScroller.querySelector('.bne-nav-menu__item.bne-nav-menu__item-active');

      if (activeMenu) {
        navScroller.scrollLeft = activeMenu.offsetLeft;
        console.log(navScroller.scrollLeft, );
      }
    }
  }

  handleResize() {
    this.initProperties();
    this.handleScroll();
    this.submenuInScreen();
  }

  calculateHeaderGroupHeight() {
    return (this.$announcementBar?.offsetHeight || 0) + this.$header.offsetHeight;
  }

  isMobileDevice() {
    return window.innerWidth < this.MOBILE_BREAKPOINT;
  }

  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  }
}

document.addEventListener('DOMContentLoaded', () => new BneMenuAnimated());
